// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CQu1fWGac2mpxW {
  height: 100%;
}
.rccdZc1gsko_Fg {
  display: flex;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: var(--ds-space-050, 4px) 10px 36px 10px;
  transition: padding 0.2s ease-in-out;
  background: var(--ds-surface, #ffffff);
}
.rccdZc1gsko_Fg .lLt7WlddiPz0aI,
.rccdZc1gsko_Fg .nyhV6pH3YwxIHU {
  position: relative;
  height: 100%;
}
.rccdZc1gsko_Fg .nyhV6pH3YwxIHU {
  border-radius: 16px;
}
.rccdZc1gsko_Fg.t877crXCv0jv2m {
  bottom: var(--ds-space-800, 64px);
}
.rccdZc1gsko_Fg.qRr926ikr8tQd2 {
  padding: var(--ds-space-0, 0);
}
.rccdZc1gsko_Fg.qRr926ikr8tQd2 .nyhV6pH3YwxIHU {
  border-radius: unset;
}
@media print {
  .rccdZc1gsko_Fg {
    flex-direction: column;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"manager": `CQu1fWGac2mpxW`,
	"splitscreen": `rccdZc1gsko_Fg`,
	"content": `lLt7WlddiPz0aI`,
	"inboxContent": `nyhV6pH3YwxIHU`,
	"tabs": `t877crXCv0jv2m`,
	"single": `qRr926ikr8tQd2`
};
export default ___CSS_LOADER_EXPORT___;
